import generalInformations from './generalInformations'
import notApplicableQuestions from './notApplicableQuestions'
import questionControls from './questionControls'

const pages = { generalInformations, notApplicableQuestions, questionControls }

export default pages
